import { useEffect, useState } from 'react';
import { Api } from '../../componentes/Api';
import { Card, CardBody,Row,Col, CardHeader, Button, Modal, ModalHeader, ModalBody, Label, Input, FormGroup, ModalFooter  } from "reactstrap"
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import Select from 'react-select';
import Moment from "moment";
import { Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';

const modeloDatos = {
    cxcID: 0, 
    empresaID: "PR",
    clienteID: 1,
    nombreCliente: "",
    rncCliente: "",
    ncfCliente: "",
    vendedor: "",
    comentario: "",
    itbis:0.00,
    subTotal: 0.00,
    formaPago: "",
    total: 0.00,
  
    creadoPor: "",
    fechaCreado: new Date,
    fechaFactura: new Date,
    estatus: 0,
   pagado:0.00
}

let movimiento = "";
let options1 = [];
const MovimientoAlmacen = () => {
    const [tabla, setTabla] = useState(modeloDatos);
    const [Listado, SetListado] = useState([]);
    const [pendiente, setPendiente] = useState(true);
    const [verModal, setVerModal] = useState(false);
    const [PagoModal, setPagoModal] = useState(false);
    const [EstadoModal, setEstadoModal] = useState(false);
    const [ver, setVer] = useState(true);
    const [Listado1, SetListado1] = useState([]);
    const [busqueda, setbusqueda] = useState("");
    const [Pagado, setPagado] = useState(0.00);
   


    const handleChange = (e) => {

        setTabla({
            ...tabla,
            [e.target.name]: e.target.value
        })
    }
    const handleChange1 = (e) => {

        if (e.target.name == "pagado" && e.target.value > (tabla.total - tabla.pagado)) {
            Swal.fire(
                'EL MONTO PAGADO!',
                'NO PUEDE SER MAYOR AL ENDEUADADO',
                'error'
            )
            e.target.value =0
        }
       setPagado(e.target.value)
    }
    const handleChange2 = (e) => {
        setTabla({
            ...tabla,
            ["clienteID"]: e.value, ["nombreCliente"]: e.nombreCliente, ["rncCliente"]: e.rncCliente, ["vendedor"]: e.vendedor
        })
    }
    const obtenerDatosCliente = async () => {
        let response = await fetch(Api + "VentasMantenimiento/listaClientes");

        if (response.ok) {
            let data = await response.json()
            options1 = []
            data.map(x => {
                options1.push({ value: x.clienteID, label: x.descripcion, nombreCliente: x.descripcion, rncCliente: x.rnc })
            })
           
        }
    }

    const onChange = async (e) => {
        var l = Listado1;
        setbusqueda(e.target.value);
        console.log(e);
        var searchData = l.filter((item) => {
            if (
                (item.nombreSuplidor + item.rncSuplidor)
                    .toString()
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase())
            ) {
                return item;
            }
        });
        SetListado(searchData);
    };

   
    const obtenerDatos = async () => {
        let response = await fetch(Api + "CXC/ListaFactura/a");
        if (response.ok) {
            let data = await response.json()
            SetListado1(data)
            if (pendiente) {
                SetListado(data)
            }
            setPendiente(false)
        }
    }
    

   

   
    useEffect(() => {
        obtenerDatos();
    
    })
    
   
    useEffect(() => {
      
        obtenerDatosCliente()
    },[])
    
   
   
    const guardarCambios = async () => {
      

        let response;
        if (tabla.cxcID == 0) {
            console.log(tabla)
            response = await fetch(Api + "CXC/GuardarRegistroCXC", {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })

        } else {
            response = await fetch(Api + "CXP/EditarRegistroCXC", {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify(tabla)
            })
        }

        if (response.ok) {
            let data = await response.json()
            obtenerDatos();
            setTabla(modeloDatos)
            tabla.movimientoAlmacenID = data.movimientoAlmacenID;
            setVer(false)
            cerrarModal()
            obtenerDatos()
            
        //    setVerModal(!verModal);
           
        } else {
            alert("error al guardar")
        }

    }

    const procesarPago = async () => {
        tabla.pagado = parseFloat(tabla.pagado)
        let response = await fetch(Api + "CXC/ProcesarPago/" + tabla.cxcID+"/"+ Pagado+"/ad/comentario");

        if (response.ok) {
            let data = await response.json()
            setPendiente(true)
          setPagado(0.00)
           
setPagoModal(false)
        }
        obtenerDatos()
    }
    const Pagar = (data) => {
        setTabla(data);
        setPagoModal(true)
    }

    const abrirEditarModal = (data, v) => {
        setVer(v);
        setTabla(data);
       
     
        setVerModal(!verModal);
    }
    const cerrarModal = () => {
        setTabla(modeloDatos)
        setVerModal(false)
    }

    const columns = [
        {
            name: 'Factura',
            selector: row => row.noFactura,
            sortable: true,
        },
        {
            name: 'Cliente',
            selector: row => row.nombreCliente,
            sortable: true,
        },
        {
            name: 'Monto',
            selector: row => formatoMoneda(row.total, 'USD', 'en-US'),
            sortable: true,
        }, {
            name: 'Pagado',
            selector: row => formatoMoneda(row.pagado, 'USD', 'en-US'),
            sortable: true,
        },
        {
            name: 'Debe',
            selector: row => formatoMoneda((row.total - row.pagado), 'USD', 'en-US'),
            sortable: true,
        },  {
            name: 'Fecha',
            selector: row => (Moment(row.fechaFactura).format("DD/MM/YYYY")),
            sortable: true,
        },
        {
            name: 'Estado',
            selector: row => row.estatus,
            sortable: true,
            cell: row => {
                let clase;
                clase = row.estatus ? "badge badge-info p-2" : "badge badge-danger p-2"
                return (
                    <span className={clase}>{row.estatus ? "PAGO" : "PENDIENTE"}</span>
                )
            }
        },
    
        {
            name: '',
            cell: row => (
                <>
                    {(row.estatus == 0)?
                     <>   <Button color="primary" size="sm" className="mr-2"
                            onClick={() => abrirEditarModal(row)}
                        >
                            <i className="fas fa-pen-alt"></i>
                        </Button> 
                        <Button color="success" size="sm" className="mr-2"
                            onClick={() => Pagar(row)}
                        >
                                <i className="fas fa-money-bill"></i>
                        </Button></> :

                        <Button color="primary" size="sm" className="mr-2"
                            onClick={() => abrirEditarModal(row, true)}
                        >
                            <i className="fas fa-eye"></i>
                        </Button>
                    }
                  
                </>
            ),
        },
    ];

    const customStyles = {
        headCells: {
            style: {
                fontSize: '13px',
                fontWeight: 800,
            },
        },
        headRow: {
            style: {
                backgroundColor: "#eee",
            }
        }
    };

    const paginationComponentOptions = {
        rowsPerPageText: 'Filas por página',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };

    // Crear una función para formatear como moneda
    function formatoMoneda(valor, moneda = 'USD', localizacion = 'en-US') {
        const formatter = new Intl.NumberFormat(localizacion, {
            style: 'currency',
            currency: moneda
        });
        return formatter.format(valor);
    }



    const generarEstadoCuenta = () => {
        const cuentas = {};

        Listado1.forEach(factura => {
            if (!cuentas[factura.clienteID]) {
                cuentas[factura.clienteID] = {
                    cliente: factura.nombreCliente,
                    facturas: [],
                    total: 0,
                    pagado: 0
                };
            }

            const pendiente = factura.total - factura.pagado;

            cuentas[factura.clienteID].facturas.push({
                noFactura: factura.noFactura,
                nombreCliente: factura.nombreCliente,
                fecha: Moment(factura.fechaFactura).format("DD/MM/YYYY"),
                total: factura.total,
                pagado: factura.pagado,
                pendiente
            });

            cuentas[factura.clienteID].total += factura.total;
            cuentas[factura.clienteID].pagado += factura.pagado;
        });

        return Object.values(cuentas);
    };

    const estadoCuenta = generarEstadoCuenta();

    return (
        <>
            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Lista de registros cuenta por pagar
                </CardHeader>
                <CardBody>
                    <Row><Col md={2}>    <Button color="success" size="sm"
                    onClick={() => setVerModal(!verModal)}
                    >Nueva Cuenta por cobrar</Button>
                    </Col>
                        
                <Col md={4}>    <Input type="search" name="busqueda" onChange={(e) => onChange(e)} placeholder="Buscar  " ></Input> </Col>
                        <Col md={2}>    <Button color="success" size="sm"
                            onClick={() => setEstadoModal(!EstadoModal)}
                        >Estado Cuenta</Button>
                        </Col>
                    </Row>  
                    <hr></hr>
                    <DataTable
                        columns={columns}
                        data={Listado}
                      progressPending={pendiente}
                       pagination
                      paginationComponentOptions={paginationComponentOptions}
                        customStyles={customStyles}
                    />
                </CardBody>
            </Card>

            <Modal className="modal-preguntas" isOpen={verModal}>
                <ModalHeader className="modal-header1">
                  
                    <div class="box">
                        <div>   Movimiento de articulo en Almacen </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={cerrarModal}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        <Col md={3}>
                            <FormGroup>

                                <Label>Cliente</Label>
                                {/*<Input bsSize="sm" type={"select"} name="suplidorID" onChange={handleChange} value={tabla.suplidorID} className="form-control"  >*/}
                                {/*     <option value={0}>Seleccionar</option>*/}
                                {/*    {*/}
                                {/*       ListadoSuplidor.map((item) => (<option key={item.suplidorID} value={item.suplidorID}>{item.descripcion}</option>))*/}
                                {/*    }*/}
                                {/*</Input>*/}
                                <Select
                                    name={"clienteID"}
                                    defaultValue={options1.filter(x => x.value == tabla.clienteID)[0]}
                                    onChange={handleChange2}
                                    options={options1}
                                />
                            </FormGroup></Col>
                        <Col md={3}>
                            <FormGroup>

                                <Label>RNC</Label>
                                <Input bsSize="sm" name="rncCliente" onChange={handleChange} value={tabla.rncCliente} />
                            </FormGroup></Col>
                        <Col md={6}>
                            <FormGroup>

                                <Label>NCF</Label>
                                <Input bsSize="sm" name="ncfCliente" onChange={handleChange} value={tabla.ncfCliente} />
                            </FormGroup></Col>
                       

                        <Col md={3}>
                            <FormGroup>
                                <Label>Vendedor</Label>
                                <Input bsSize="sm" name="vendedor" onChange={handleChange} value={tabla.vendedor} />

                                {/*<Input bsSize="sm" type={"select"} name="tipoTransaccionID" onChange={handleChange} value={tabla.tipoTransaccionID} className="form-control" >*/}
                                {/*    <option value={'+'}>Entrada</option>*/}
                                {/*    <option value={'-'}>Salida</option>*/}
                                   

                                {/*</Input>*/}
                            </FormGroup>                        </Col>
                        <Col md={3}>
                            <FormGroup>

                                <Label>Comentario</Label>
                                <Input bsSize="sm" name="comentario" onChange={handleChange} value={tabla.comentario} />
                            </FormGroup></Col>
                        <Col md={3}>
                            <FormGroup>

                                <Label>ITBIS</Label>
                                <Input bsSize="sm" type="number" name="itbis" onChange={handleChange} value={tabla.itbis} />
                            </FormGroup></Col>
                        <Col md={3}>
                            <FormGroup>

                                <Label>SupTotal</Label>
                                <Input bsSize="sm" type="number" name="subTotal" onChange={handleChange} value={tabla.subTotal} />
                            </FormGroup></Col>
                        <Col md={3}>
                            <FormGroup>

                                <Label>Total</Label>
                                <Input bsSize="sm" type="number" name="total" onChange={handleChange} value={tabla.total} />
                            </FormGroup></Col>
                        <Col md={3}>
                            <FormGroup>

                                <Label>Forma de Pago</Label>
                                <Input bsSize="sm" name="formaPago" onChange={handleChange} value={tabla.formaPago} />
                            </FormGroup></Col>
                    
                    <Col md={3}>
                            <FormGroup>

                                <Label>Fecha Factura</Label>
                                <Input bsSize="sm" type="date" name="fechaFactura" onChange={handleChange} value={Moment(tabla.fechaFactura).format('YYYY-MM-DD')} />
                            </FormGroup></Col>
                    </Row>
                    <div>
                        <Row hidden={ver}>
                        <Col md={6}>
                        <FormGroup>
                        <Label> Articulo</Label>
                                  
                            </FormGroup>
                        </Col>
                       
                       
                    </Row>
                    
                        <Row>
                       
                    </Row>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button hidden={!ver } size="sm" color="primary"
                        onClick={guardarCambios}
                    >Guardar</Button>
                    <Button size="sm" color="danger"
                      onClick={cerrarModal}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>

            {/*Procesar pago*/}
            <Modal isOpen={PagoModal}>
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div> Cobro de Factura </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setPagoModal(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>
                    <Row>
                        
                         <p>   Suplidor: <b>{tabla.nombreSuplidor}</b>    </p>
                         <p>   Monto Pendiente de pago: <b>{tabla.total - tabla.pagado}</b>    </p>
                    
                        <Col >
                            <FormGroup>
                                <Label>Monto a Pagar</Label>
                                <Input bsSize="sm" name="pagado" onChange={handleChange1} value={Pagado } />
                            </FormGroup>
                        </Col>
                      
                    </Row>
                </ModalBody>
                <ModalFooter>
                    { (Pagado  > 0)&&
                    <Button size="sm" color="primary"
                        onClick={procesarPago}
                    >Procesar Pago</Button> }
                    <Button size="sm" color="danger"
                        onClick={() => setPagoModal(false)}
                    >Cerrar</Button>
                </ModalFooter>
            </Modal>


            <Modal className="modal-preguntas" isOpen={EstadoModal}>
                <ModalHeader className="modal-header1">
                    <div class="box">
                        <div> Estado </div>
                        <div><a className="btn" style={{ color: "#ffff" }} onClick={() => setEstadoModal(false)}>X</a></div>
                    </div>
                </ModalHeader>
                <ModalBody>

            <Card>
                <CardHeader style={{ backgroundColor: '#4e73df', color: "white" }}>
                    Estado de Cuenta por Cliente
                </CardHeader>
                <CardBody>
                            {estadoCuenta.map((cliente, index) => (
                        <div key={index} style={{ marginBottom: "2rem" }}>
                            <h5>{cliente.cliente}</h5>
                            <table className="table table-bordered table-sm">
                                <thead className="thead-light">
                                    <tr>
                                        <th>Factura</th>
                                        <th>Nombre</th>
                                        <th>Fecha</th>
                                        <th>Total</th>
                                        <th>Pagado</th>
                                        <th>Pendiente</th>
                                    </tr>
                                </thead>
                                <tbody>
                                            {cliente.facturas.filter(x => x.pendiente > 0).map((f, i) => (
                                        <tr key={i}>
                                            <td>{f.noFactura}</td>
                                            <td>{f.nombreCliente}</td>
                                            <td>{f.fecha}</td>
                                            <td>{formatoMoneda(f.total)}</td>
                                            <td>{formatoMoneda(f.pagado)}</td>
                                            <td>{formatoMoneda(f.pendiente)}</td>
                                        </tr>
                                    ))}
                                    <tr className="table-secondary font-weight-bold">
                                        <td >Totales</td>
                                        <td colSpan="2">{cliente.facturas.length}</td>
                                        <td>{formatoMoneda(cliente.total)}</td>
                                        <td>{formatoMoneda(cliente.pagado)}</td>
                                        <td>{formatoMoneda(cliente.total - cliente.pagado)}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    ))}
                </CardBody>
            </Card>
        </ModalBody >
            <ModalFooter>
                
                <Button size="sm" color="danger"
                        onClick={() => setEstadoModal(false)}
                >Cerrar</Button>
            </ModalFooter>
            </Modal >
        </>
        )

}
export default MovimientoAlmacen;